export default function () {
  return {
    showMobileLoyaltyProgram: false,
    history: [],
  }
}
